import styles from '../new-trip.module.css';
import {API_URL} from '../../utils/fatch';
import { useState } from 'react';




export const DestinationSuggestions = (props) => {

    let timerId;
    
const [currantInputValue, setCurrantInputValue] = useState(props.destination);

    const handleInputChange = (e) => {
          setCurrantInputValue(e.target.value); 
        clearTimeout(timerId);
        timerId = setTimeout(async () => {
            const destinationTypeing = e.target.value;
            if (destinationTypeing.length < 1) {
                props.setSuggestions([]);
                return;
            }
            try {
                const response = await fetch(`${API_URL}/maps/autocomplete/${destinationTypeing}`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (!response.ok) {
                    const data = await response.json();
                    console.error(data);
                    return;
                }
                const data = await response.json();
                console.log(data);
                props.setSuggestions(data.suggestions);
            } catch (error) {
                console.error('Error adding new trip:', error);
            }
        }, 300);
    };



    const handleSelectedInput = async (place_id) => {
        try {
            const response = await fetch(`${API_URL}/maps/placeInfo/${place_id}`, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                const data = await response.json();
                console.error(data);
                return;
            }
            const data = await response.json();
            console.log(data);


            props.setCountry(data.country);
            props.setCity(data.city);
            props.setNeighborhood(data.neighborhood);
            props.setState(data.state);









            props.setDestination(data.name);
            props.setDestinationOpen(false);

        } catch (error) {
            console.error('Error adding new trip:', error);
        }
    };









 
    



    return (
/* rgb(230, 230, 219) */
        <div className={styles.desSection}>
       <div className={styles.search}
            style={{
                marginTop: props.destination.length > 0 ? '8px' : undefined,
            }}
>

                <div className={styles.suggestionsInputInner}>
                    <input type="text" id="new-trip-destination" onChange={(e) => handleInputChange(e)} onFocus={(e) => handleInputChange(e)} name="destination" value={currantInputValue} placeholder="Search a city, region or country" autoComplete='off'
                      autoFocus />

                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg>
                    </div>

                </div>
            </div>

            {props.suggestions.length > 0 &&







                <div className={styles.suggestions}>
                    <p className={styles.suggestionsHint}>Please select one</p>
                    <ul>
                        {props.suggestions.map((s) => (
                            <li key={s.place_id} onClick={() => handleSelectedInput(s.place_id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg>
                                <p>{s.description}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>

    );
};